module.exports = __webpack_public_path__ + "static/img/1-12.522e18f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-12.png
// module id = Rb8U
// module chunks = 15